import React from "react";
import styled from 'styled-components';
import { Icon } from '@workboard/action-item';
import { WbMarkdownHtml, displayTimeAsHrsMins, sanitize } from "../../utils/common";
import ImgIconComp from "../imgcomp";
import { getAiTypeAttributeIconName } from '../../board/utils';
import { EAiIssueTypeAttrNames } from '../../board/types/ai.types';
import { withTranslation } from "react-i18next";
import StructuredReviewSummary from './StructuredReviewSummary';

const IconWrapper = styled.span``;

const AgendaAiDetailsWrapper = styled.div`
  display: flex;
  gap: 5px;
  width: 90px;
  svg {
    margin-top: 2px;
  }
`;

const StateIcon = ({ type, value, name }) => {
  const iconName = getAiTypeAttributeIconName(type, name ?? EAiIssueTypeAttrNames.STATE, value);
  return <Icon name={iconName} width="15" height="15" />;
}

/* Publish meeting */
class PublishSummaryMeeting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      meetingObj: this.props.meetingObj,
      imageLogo: ""
    };
    this.publishEmailPopup = this.publishEmailPopup.bind(this);
    this.printMeetingSummary = this.printMeetingSummary.bind(this);
    this.publishBackLink = this.publishBackLink.bind(this);
  }

  componentDidMount() {
    const _this = this;
    let imageLogos = "";
    $.ajax({
      url: `${wbConfig.baseUrl}/meeting/getLogo`,
      type: "get"
    }).done(resp => {
      imageLogos = resp.orgLogoPath;
      setTimeout(() => {
        _this.setState({
          imageLogo: imageLogos
        });
      }, 10);
    });
  }

  publishEmailPopup() {
    // TODO: needs some refactoring
    const groupMeeting = this.props.meetingObj.type != 1 ? 1 : 0;
    showLoaderWidget($("#content"));
    const { id } = this.props.meeting;
    $.get(
      wbConfig.baseUrl + '/meeting/resendMeetingSummary',
      { meetingId: id, type: "meetingSummery", groupMeeting },
      response => {
        removeLoader();
        if (response.error) {
          alert(response.error);
        } else {
          resendMeetingSummaryPopupDialog
            .html("")
            .html(response)
            .dialogOpen();
        }
      }
    );
    // This is not a random duplicate, your eyes are fine. 
    // This duplicate is need it, due to some unknowns on JQuery not 
    // populating a dropdown on the first time the file is render on the DOM,
    // so second call makes the code "happy". This need a rewrite, please.
    $.get(
      wbConfig.baseUrl + '/meeting/resendMeetingSummary',
      { meetingId: id, type: "meetingSummery", groupMeeting },
      response => {
        removeLoader();
        if (response.error) {
          alert(response.error);
        } else {
          resendMeetingSummaryPopupDialog
            .html("")
            .html(response)
            .dialogOpen();
        }
      }
    );
  }

  printMeetingSummary() {
    window.open(
      `${wbConfig.baseUrl}/meeting/meetingDetails?id=${this.props.meeting.id}&printMeeting=1`,
      "_blank"
    );
  }

  publishBackLink() {
    if ($(".memberPage").length) {
      const selected = $("#otherPriority").tabs("option", "active");
      showLoaderWidget($("#otherPriority"));
      tabReload();
      removeLoaderWidget();
    } else {
      ajaxPageLoad(
        `${wbConfig.baseUrl}/meeting/meetingDetails?id=${this.props.meeting.id}`,
        undefined,
        undefined,
        undefined,
        "backMeeting",
        () => {
          activeLeftMenuId("meeting");
        }
      );
    }
  }

  render() {
    const { t } = this.props;
    const { meeting } = this.props;
    const { dateDropdown } = this.props;
    const orgLogoPath = this.state.imageLogo;
    const { selectedUser } = this.props;
    const { meeting_invitees } = this.props;
    const { meeting_takes } = this.props;
    const { meeting_topics } = this.props;
    const { currentUser } = this.props;
    const meetingTitle =
      meeting.type == 1
        ? `${currentUser.fullName}'s 1on1 with ${selectedUser.firstname}`
        : `${meeting.name} Team Meeting Summary`;
    const printSummaryMeeting = this.props.printMeeting == "1";
    let meetingTopicDecision = false;
    let meetingTakeDecision = false;
    let meetingTopicTakeD = false;

    if (meeting_topics && typeof meeting_topics !== "undefined" && meeting_topics.length > 0) {
      meeting_topics.map(top => {
        if (top.tag == "3") {
          meetingTopicDecision = true;
        }

        if (
          top.topic_take &&
          typeof top.topic_take !== "undefined" &&
          top.topic_take.length > 0
        ) {
          top.topic_take.map(item => {
            if (item.tag == "3") {
              meetingTopicTakeD = true;
            }
          });
        }
      });
    }
    if (meeting_takes && typeof meeting_takes !== "undefined" && meeting_takes.length > 0) {
      meeting_takes.map(take => {
        if (take.tag == "3") {
          meetingTakeDecision = true;
        }
      });
    }
    const timeSpent = meeting.time_spent;
    const meetingSpentTime = displayTimeAsHrsMins(timeSpent);

    let dropDateStr = "";
    let dropDayStr = "";
    dateDropdown.map(dropDate => {
      if (dropDate.id == meeting.id) {
        dropDateStr = dropDate.name;
        dropDayStr = dropDate.day;
      }
    });
    return (
      <div className="meetingPublishSummaryDetail">
        <div>
          <div className="meetingPublishTitle">{meetingTitle}</div>
          <div className="emailAndPrint" style={{ left: "0%" }}>
            <img
              onClick={this.publishEmailPopup}
              className="sendSummary"
              src={`${wbConfig.baseUrl}/images/icons/dropdowns/email@3x.png`}
              style={{ width: "25px" }}
            />
            <img
              onClick={this.printMeetingSummary}
              className="printImage"
              src={`${wbConfig.baseUrl}/images/icons/dropdowns/print@3x.png`}
              style={{ width: "40px" }}
            />
          </div>
        </div>

        <div className="meetingPublishTimeDetails">
          {meeting.location != "" && (
            <div className="meetingPublishMember ">{meeting.location}</div>
          )}
          <div className="meetingPublishDate ">{`${dropDayStr} ${dropDateStr}`}</div>
          <div className="meetingPublishTime ">
            {meetingSpentTime != '' ? t('Duration:', { nsSeparator: false }) : ''}
            <strong>{meetingSpentTime}</strong>
          </div>
        </div>
        {meeting.type != 1 && (
          <div className="meetingPublishAgendaDesc">{t('DESCRIPTION')}</div>
        )}
        {meeting.type != 1 && (
          <div className="meetingPublishTimeDetails meetingPublishText">
            <div dangerouslySetInnerHTML={WbMarkdownHtml(meeting.description ?? meeting.objective, true)} />
          </div>
        )}
        <div className="agendaDecisionsAttendeesWrapper">

          {meeting_topics.length > 0 && (
            <div className="meetingPublishAgenda">{t('AGENDA/TAKEAWAYS')}</div>
          )}
          <div className="takeawaysWrapper">
            {meeting_topics.map(
              (item, index) =>
                (item.description != "" ||
                  (typeof item.topic_take !== "undefined" &&
                    item.topic_take.length > 0)) && (
                  <div
                    key={index}
                    className="agendaTakeAwaysData"
                    style={{
                      borderBottom:
                        item.description != ""
                          ? "0px solid #E1F3F8"
                          : "0",
                      display:
                        item.access == 0 &&
                          meeting.type == 1 &&
                          item.added_by != currentUser.id
                          ? "none"
                          : ""
                    }}
                  >
                    {item.description != "" && (
                      <div className="meetingPublishAgendaDetails">
                        <div
                          className={`agendaPublishImages ${item.wobo_type} ${item.tag}`}
                        >
                          {item.wobo_type == "ai" ? (
                            <IconWrapper>
                              <StateIcon type={item.wobo_data.type} value={item.wobo_data.state} />
                            </IconWrapper>
                          ) : (
                            <div
                              className="meeting-tag-options meeting-tag-bullet meetingTopicImage meeting-dec-img"
                              data-tag={
                                item.wobo_type == "topic"
                                  ? item.tag
                                  : item.wobo_type_id
                              }
                              data-type={item.wobo_type}
                            />
                          )}
                        </div>
                        {item.wobo_type == "attachment" ? (
                          <div
                            className="agendaTopicdescription truncate3"
                            style={{ width: "71%" }}
                          >
                            {item.description}
                          </div>
                        ) : (
                          <div
                            className="agendaPublishtext truncate3 wrap"
                            style={{ flexGrow: 1, maxWidth: 'calc(100% - 100px)' }}
                          >
                            <div
                              className="agendaPublishtext truncate3 wrap dispIB"
                              dangerouslySetInnerHTML={{ __html: sanitize(item.description) }}
                            />
                            {item.recurringTopic == 1 && (
                              <ImgIconComp
                                id="recurringTemp"
                                class="recuuringPic dispIB"
                                width="20"
                                height="20"
                              />
                            )}
                          </div>
                        )}
                        {item.wobo_type == "workstream" && (
                          <div className="agendaPercentageValue">
                            <div
                              className="publish-ws-health"
                              data-value={item.wobo_data.health}
                            />

                            <div
                              className="publish-ws-progress"
                              style={{ color: item.wobo_data.progress_color }}
                            >
                              {item.wobo_data.progress != ""
                                ? `${item.wobo_data.progress}%`
                                : "0%"}
                            </div>
                          </div>
                        )}
                        {item.wobo_type == "objective" && (
                          <div
                            className="agendaPercentageValue"
                            style={{ color: item.wobo_data.goal_percentage_color }}
                          >
                            {item.wobo_data.progress.indexOf("-1") >= 0 ||
                              item.wobo_data.progress < 0
                              ? "--"
                              : `${item.wobo_data.progress}%`}
                          </div>
                        )}
                        {item.wobo_type == "ai" && (
                          <AgendaAiDetailsWrapper>
                            <IconWrapper>
                              <StateIcon
                                type={item.wobo_data.type}
                                name={EAiIssueTypeAttrNames.PRIORITY}
                                value={item.wobo_data.priority}
                              />
                            </IconWrapper>
                            <IconWrapper>
                              <StateIcon
                                type={item.wobo_data.type}
                                name={EAiIssueTypeAttrNames.RAG}
                                value={item.wobo_data.rag}
                              />
                            </IconWrapper>
                            <span
                              className="aiDueDate"
                              style={{ verticalAlign: "super" }}
                            >
                              {moment
                                .utc(item.wobo_data.due_date * 1000)
                                .format("MMM DD")}
                            </span>
                          </AgendaAiDetailsWrapper>
                        )}
                        {item.wobo_type == "key_result" && (
                          <div
                            className="agendaPercentageValue"
                            style={{ color: item.wobo_data.progress_color }}
                          >
                            {item.wobo_data.achieve_target_text}
                          </div>
                        )}
                        {item.wobo_type == "topic" && (
                          <div
                            className="agendaPublishPeople"
                            style={{ marginLeft: "30px" }}
                          >
                            {`${item.firstname} ${item.lastname}`}{" "}
                            {item.created_date}
                          </div>
                        )}
                      </div>
                    )}
                    {item.files != "" &&
                      (typeof item.files !== "undefined" &&
                        item.files.length > 0) &&
                      item.files.map(file => (
                        <div key={`item_file_${Math.floor(Math.random() * 10000)}`}>
                          <div
                            className="meetingPublishAgendaDetails"
                            style={{ padding: "5px 0px" }}
                          >
                            <div className="agendaPublishImages">
                              <div
                                className="meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                data-tag="14"
                                data-type="ai"
                              />
                            </div>
                            <div className="agendaPublishtext truncate3 wrap">
                              {file.file_name}
                            </div>
                          </div>
                          <div
                            className="agendaDescriptionMember takeAwayDesc"
                            style={{ marginLeft: "30px" }}
                          >
                            {file.fullName}
                          </div>
                          <div className="agendaDescriptionTime">
                            {moment
                              .utc(file.create_at * 1000)
                              .format("hh:mm a MMM DD,YYYY")}
                          </div>
                        </div>
                      ))}
                    {item.description != "" && (
                      <div className="meetingPublishAgendaDetails">
                        <div className="agendaPublishImages" />
                        {item.wobo_type == "key_result" && (
                          <div className="agendaPrintPeople">
                            {item.wobo_data.ownerName
                              ? item.wobo_data.ownerName
                              : ""}
                            {item.wobo_data.goalName
                              ? ` : ${item.wobo_data.goalName}`
                              : ""}
                          </div>
                        )}
                        {item.wobo_type == "workstream" && (
                          <div className="agendaPrintPeople">
                            {item.wobo_data.wsLeadName
                              ? item.wobo_data.wsLeadName
                              : ""}{" "}
                            {item.wobo_data.teamName
                              ? ` : ${item.wobo_data.teamName}`
                              : ""}
                          </div>
                        )}
                        {item.wobo_type == "objective" && (
                          <div className="agendaPrintPeople">
                            {item.wobo_data.ownerName
                              ? item.wobo_data.ownerName
                              : ""}
                            {item.wobo_data.teamName
                              ? ` : ${item.wobo_data.teamName}`
                              : ""}
                          </div>
                        )}
                        {item.wobo_type == "topic" && (
                          <div className="agendaPublishPeople" />
                        )}
                        {item.wobo_type == "ai" && (
                          <div className="agendaPrintPeople">
                            {item.wobo_data.wsName ? item.wobo_data.wsName : ""}
                            {item.wobo_data.ownerName
                              ? ` : ${item.wobo_data.ownerName}`
                              : ""}
                          </div>
                        )}
                        {item.wobo_type == "attachment" && (
                          <div className="agendaPublishPeople">
                            {`${item.firstname} ${item.lastname}`}{" "}
                            {item.created_date}
                          </div>
                        )}
                      </div>
                    )}
                    {typeof item.topic_take !== "undefined" &&
                      item.topic_take.length > 0
                      ? item.topic_take.map(take => (
                        <div
                          key={`item_topic_take_${Math.floor(
                            Math.random() * 10000
                          )}`}
                        >
                          <div
                            className="meetingPublishAgendaIndDetails"
                            style={{
                              marginLeft: item.description != "" ? "30px" : "0px",
                              borderBottom:
                                item.description != ""
                                  ? "0px"
                                  : "0px solid #E1F3F8",
                              paddingBottom:
                                item.description != "" ? "0px" : "10px"
                            }}
                          >
                            {take.state != null ? (
                              <IconWrapper style={{ paddingRight: '5px' }}>
                                <StateIcon type={take.wobo_data.type} value={take.wobo_data.state} />
                              </IconWrapper>
                            ) : (
                              <div
                                className="agendaPublishImages meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                data-id={take.id}
                                data-tag={take.tag}
                                data-type="take"
                                style={{
                                  marginLeft:
                                    item.description != "" ? "0px" : "-4px"
                                }}
                              />
                            )}
                            <div
                              className="agendaDescription"
                              style={{
                                marginLeft: item.description != "" ? "0px" : "4px"
                              }}
                            >
                              {take.tag == 1 ? (
                                <div style={{display: 'flex'}}>
                                  <div
                                    className="agendaDescription  truncate3 wrap"
                                    dangerouslySetInnerHTML={{
                                      __html: sanitize(take.description)
                                    }}
                                    style={{ maxWidth: 'calc(100% - 100px)' }}
                                  />
                                  <AgendaAiDetailsWrapper>
                                    <IconWrapper>
                                      <StateIcon
                                        type={take.wobo_data.type}
                                        name={EAiIssueTypeAttrNames.PRIORITY}
                                        value={take.wobo_data.priority}
                                      />
                                    </IconWrapper>
                                    <IconWrapper>
                                      <StateIcon
                                        type={take.wobo_data.type}
                                        name={EAiIssueTypeAttrNames.RAG}
                                        value={take.wobo_data.rag}
                                      />
                                    </IconWrapper>
                                    <span
                                      className="aiDueDate"
                                      style={{ verticalAlign: "super" }}
                                    >
                                      {moment(
                                        take.wobo_data.due_date * 1000
                                      ).format("MMM DD")}
                                    </span>
                                  </AgendaAiDetailsWrapper>
                                </div>
                              ) : (
                                <div
                                  className="agendaDescription truncate3 wrap"
                                  dangerouslySetInnerHTML={{
                                    __html: sanitize(take.description)
                                  }}
                                />
                              )}
                              {take.tag == 0 || take.tag == 3 ? (
                                <div className="agendaDescriptionMember takeAwayDesc">{`${take.firstname} ${take.lastname}`}</div>
                              ) : (
                                <div
                                  className="agendaDescriptionMember takeAwayDesc"
                                  style={{ fontStyle: "normal" }}
                                >{take.wobo_data != undefined && take.wobo_data.wsName ? `${take.wobo_data.wsName} : ` : ""} {take.wobo_data != undefined ? `${take.wobo_data.firstname} ${take.wobo_data.lastname}` : `${take.firstname} ${take.lastname}`}</div>
                              )}
                              {take.tag == 0 || take.tag == 3 ? (
                                <div className="agendaDescriptionTime">
                                  {take.created_date}
                                </div>
                              ) : (
                                <div
                                  className="agendaDescriptionTime"
                                  style={{ fontStyle: "normal" }}
                                >
                                  {take.created_date}
                                </div>
                              )}
                            </div>
                          </div>
                          {take.files != "" &&
                            (typeof take.files !== "undefined" &&
                              take.files.length > 0) &&
                            take.files.map(file => (
                              <div
                                key={`take_files_${Math.floor(
                                  Math.random() * 10000
                                )}`}
                              >
                                <div
                                  className="meetingPublishAgendaIndDetails"
                                  style={{
                                    padding: "5px 0px",
                                    marginLeft: "34px"
                                  }}
                                >
                                  <div className="agendaPublishImages">
                                    <div
                                      className="meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                      data-tag="14"
                                      data-type="ai"
                                    />
                                  </div>
                                  <div
                                    className="agendaPublishtext truncate3 wrap"
                                    style={{ minWidth: "60%", maxWidth: "60%" }}
                                    dangerouslySetInnerHTML={{
                                      __html: file.file_name
                                    }}
                                  />
                                </div>
                                <div
                                  className="agendaDescriptionMember takeAwayDesc"
                                  style={{ marginLeft: "65px" }}
                                >
                                  {file.fullName}
                                </div>
                                <div className="agendaDescriptionTime">
                                  {file.created_at}
                                </div>
                              </div>
                            ))}
                        </div>
                      ))
                      : ""}
                  </div>
                )
            )}
          </div> {/* /takeawaysWrapper */}
          <div className={meeting_takes.length ? "meetingPublishAgenda" : ""}>
            {meeting_takes.map((item, index) => {
              return (
                <div className="agendaTakeAwaysData takeAwayFont" key={index}>
                  <div
                    className="agendaPublishImages takeAwayimage meeting-tag-options meeting-tag-bullet meetingTopicImage"
                    data-id={item.id}
                    data-tag={item.tag}
                    data-type="take"
                  >
                    {" "}
                  </div>
                  <div className="agendaDescription">
                    <div
                      className="agendaDescription takeAwayDesc truncate3 wrap"
                      dangerouslySetInnerHTML={{ __html: sanitize(item.description) }}
                    />
                    {item.firstname && item.lastname &&
                      <div className="agendaDescriptionMember takeAwayDesc">{`${item.firstname} ${item.lastname}`}</div>
                    }
                    <div className="agendaDescriptionTime">{item.created_date}</div>
                  </div>
                </div>
              )
            }
            )}
          </div>

          <StructuredReviewSummary meetingId={this.props.meeting.id} />

          <div className="meetingDecision">
            {(meetingTakeDecision ||
              meetingTopicDecision ||
              meetingTopicTakeD) && (
                <div className="publishMeetingAttendeeTitle">{t('DECISIONS')}</div>
              )}
            <div className="decisionsWrapper">
              {meeting_topics.map((items, index) => {
                return (
                  items.tag == 3 ? (
                    <div
                      data-sec="reltaketopic"
                      style={{
                        display:
                          items.access == 0 &&
                            meeting.type == 1 &&
                            items.added_by != currentUser.id
                            ? "none"
                            : ""
                      }}
                      key={index}
                    >
                      <div
                        className="agendaTakeAwaysData takeAwayFont"
                        data-test="topic"
                        data-tag={items.tag}
                        style={{
                          borderBottom:
                            items.description != "" && items.tag == 3
                              ? "border-bottom: 0px solid #E1F3F8"
                              : "0"
                        }}
                      >
                        {
                          <div>
                            {items.tag == 3 && items.description != "" && (
                              <div>
                                <div className="agendaPublishImages">
                                  <div
                                    className="takeAwayimage meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                    data-id={items.id}
                                    data-tag={items.tag}
                                    data-type="take"
                                  >
                                    {" "}
                                  </div>
                                </div>
                                <div className="agendaDescription">
                                  <div
                                    className="agendaDescription takeAwayDesc truncate3 wrap"
                                    dangerouslySetInnerHTML={{
                                      __html: sanitize(items.description)
                                    }}
                                  />
                                  <div className="agendaDescriptionMember takeAwayDesc">{`${items.firstname} ${items.lastname}`}</div>
                                  <div className="agendaDescriptionTime">
                                    {items.created_date}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        }
                        {items.files != "" &&
                          (typeof items.files !== "undefined" &&
                            items.files.length > 0) &&
                          (items.tag == 3 && items.description != "") &&
                          items.files.map(file => (
                            <div
                              key={`meeting_publish_agenda_details_${Math.floor(
                                Math.random() * 10000
                              )}`}
                            >
                              <div
                                className="meetingPublishAgendaDetails"
                                style={{ padding: "5px 0px" }}
                              >
                                <div className="agendaPublishImages">
                                  <div
                                    className="meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                    data-tag="14"
                                    data-type="ai"
                                  />
                                </div>
                                <div
                                  className="agendaPublishtext truncate3 wrap"
                                  dangerouslySetInnerHTML={{
                                    __html: file.file_name
                                  }}
                                />
                              </div>

                              <div
                                className="agendaDescriptionMember takeAwayDesc"
                                style={{ marginLeft: "65px" }}
                              >
                                {file.fullName}
                              </div>
                              <div className="agendaDescriptionTime">
                                {file.created_at}
                              </div>
                            </div>
                          ))}
                      </div>
                      {items.topic_take && items.topic_take.map((take, index) => {
                        return (
                          <div
                            className="agendaTakeAwaysData takeAwayFont"
                            data-test="takeR"
                            data-tag={take.tag}
                            style={{
                              borderBottom:
                                items.description != "" && take.tag == 3
                                  ? "border-bottom: 0px solid #E1F3F8"
                                  : "0",
                              display:
                                take.tag != 3 &&
                                  items.access == 0 &&
                                  meeting.type == 1 &&
                                  items.added_by != currentUser.id
                                  ? "none"
                                  : ""
                            }}
                            key={index}
                          >
                            {take.tag == 3 && take.description != "" && (
                              <div>
                                <div className="agendaPublishImages">
                                  <div
                                    className="takeAwayimage meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                    data-id={take.id}
                                    data-tag={take.tag}
                                    data-type="take"
                                  >
                                    {" "}
                                  </div>
                                </div>
                                {take.description != "" && (
                                  <div className="agendaDescription">
                                    <div
                                      className="agendaDescription takeAwayDesc truncate3 wrap"
                                      dangerouslySetInnerHTML={{
                                        __html: sanitize(take.description)
                                      }}
                                    />
                                    <div
                                      className="agendaDescriptionMember takeAwayDesc"
                                      style={{ marginLeft: "0px" }}
                                    >{`${take.firstname} ${take.lastname}`}</div>
                                    <div className="agendaDescriptionTime">
                                      {take.created_date}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                            {take.files != "" &&
                              (typeof take.files !== "undefined" &&
                                take.files.length > 0) &&
                              (take.tag == 3 && take.description != "") &&
                              take.files.map(file => (
                                <div
                                  key={`meeting_publish_agenda_details_${Math.floor(
                                    Math.random() * 10000
                                  )}`}
                                >
                                  <div
                                    className="meetingPublishAgendaDetails"
                                    style={{ padding: "5px 0px" }}
                                  >
                                    <div className="agendaPublishImages">
                                      <div
                                        className="meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                        data-tag="14"
                                        data-type="ai"
                                      />
                                    </div>
                                    <div
                                      className="agendaPublishtext truncate3 wrap"
                                      dangerouslySetInnerHTML={{
                                        __html: file.file_name
                                      }}
                                    />
                                  </div>
                                  <div
                                    className="agendaDescriptionMember takeAwayDesc"
                                    style={{ marginLeft: "65px" }}
                                  >
                                    {file.fullName}
                                  </div>
                                  <div className="agendaDescriptionTime">
                                    {file.created_at}
                                  </div>
                                </div>
                              ))}
                          </div>
                        )
                      })}
                    </div>
                  ) : (
                    <div
                      data-sec="reltake"
                      style={{
                        display:
                          items.access == 0 &&
                            meeting.type == 1 &&
                            items.added_by != currentUser.id
                            ? "none"
                            : ""
                      }}
                    >
                      {items.topic_take && items.topic_take.map(
                        (take, index) =>
                          take.tag == 3 &&
                          take.description != "" && (
                            <div
                              className="agendaTakeAwaysData takeAwayFont"
                              data-test="ntake"
                              data-tag={take.tag}
                              style={{
                                borderBottom:
                                  take.description != ""
                                    ? "border-bottom: 0px solid #E1F3F8"
                                    : "0"
                              }}
                              key={index}
                            >
                              <div>
                                <div className="agendaPublishImages">
                                  <div
                                    className="takeAwayimage meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                    data-id={take.id}
                                    data-tag={take.tag}
                                    data-type="take"
                                  >
                                    {" "}
                                  </div>
                                </div>
                                <div className="agendaDescription">
                                  <div
                                    className="agendaDescription takeAwayDesc truncate3 wrap"
                                    dangerouslySetInnerHTML={{
                                      __html: sanitize(take.description)
                                    }}
                                  />
                                  <div className="agendaDescriptionMember takeAwayDesc">{`${take.firstname} ${take.lastname}`}</div>
                                  <div className="agendaDescriptionTime">
                                    {take.created_date}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                      )}
                    </div>
                  )
                )
              }
              )}

              {meeting_takes.map(
                (items, index) =>
                  items.tag == 3 &&
                  items.description != "" && (
                    <div
                      className="agendaTakeAwaysData takeAwayFont"
                      data-tag={items.tag}
                      key={index}
                    >
                      <div data-sec="notake">
                        <div
                          className="agendaPublishImages takeAwayimage meeting-tag-options meeting-tag-bullet meetingTopicImage"
                          data-id={items.id}
                          data-tag={items.tag}
                          data-type="take"
                        >
                          {" "}
                        </div>
                        <div className="agendaDescription">
                          <div
                            className="agendaDescription takeAwayDesc truncate3 wrap"
                            dangerouslySetInnerHTML={{
                              __html: sanitize(items.description)
                            }}
                          />
                          <div className="agendaDescriptionMember takeAwayDesc">{`${items.firstname} ${items.lastname}`}</div>
                          <div className="agendaDescriptionTime">
                            {items.created_date}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
              )}
            </div> {/* /decisionsWrapper */}
          </div> {/* /meetingDecision */}


          {meeting.type != 1 && (
            <div className="publishMeetingAttendee">
              <div className="publishMeetingAttendeeTitle">{t('ATTENDEES')}</div>
              <div className="attendeeWidth">
                {meeting_invitees.map(
                  (invitee, index) =>
                    invitee.access == "1" && (
                      <div className="attendeeDetails" key={index}>
                        <div className="attendee-img">
                          <img
                            src={invitee.picture}
                            className="fitProfileImage goal-user-picture attendeePic roundFramePhoto"
                          />
                        </div>
                        <div className="attendeeName">{invitee.user_name}</div>
                      </div>
                    )
                )}
              </div>
            </div>
          )}
        </div> {/* /agendaDecisionsAttendeesWrapper */}
        {!printSummaryMeeting && !window.wbConfig.isNewMeetingsEnabled && (
          <div
            className="publishMeetingAttendee"
            style={{ padding: "1% 0% 1% 39%" }}
          >
            <div
              onClick={this.publishBackLink}
              className="back-meeting-publish"
            >
              {" "}
              {t('Go to the meeting')}
            </div>
          </div>
        )}
        <div
          className="publishMeetingAttendee"
          style={{ padding: "3% 0% 1% 42%" }}
        >
          <img width="117px" height="auto" src={orgLogoPath} />
        </div>
      </div>
    );
  }
}
export default withTranslation()(PublishSummaryMeeting);
